import { mapState } from 'pinia'
import { defineComponent } from 'vue'

import { useMiscResizeStore } from '~/stores/miscResize'

/**
 * DEPRECATED MIXIN
 * FROM NOW ON PLEASE JUST MAP THE REQUIRED STATE IN THE CONTROLLER.
 *
 * @deprecated
 * @returns {any} - DEPRECATED STUFF.
 */
export default defineComponent({
  computed: {
    ...mapState(useMiscResizeStore, ['screenWidth', 'screenHeight']),
    // ...mapState({
    //   screenWidth: (state: any) => state.misc.resize.screenWidth,
    //   screenHeight: (state: any) => state.misc.resize.screenHeight,
    // }),
  },
})
